import { Link } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { siInstagram, siFacebook, siYoutube } from 'simple-icons'
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md'
import './Footer.css'
const footerLinks = {
  company: [
    { label: 'About Us', path: '/about' },
    { label: 'Our Team', path: '/team' },
    { label: 'Philosophy', path: '/philosophy' },
    { label: 'Careers', path: '/careers' },
  ],
  explore: [
    // { label: 'Flavours', path: '/menu' },
    { label: 'Our Stores', path: '/stores' },
    { label: 'Franchise', path: '/franchise' },
    { label: 'Contact Us', path: '/contact' },
  ],
}

export default function Footer() {
  const footerRef = useRef(null)
  
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.footer-content > *',
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: footerRef.current,
            start: 'top 80%',
          }
        }
      )
    }, footerRef)
    
    return () => ctx.revert()
  }, [])

  return (
    <footer className="footer" ref={footerRef}>
      {/* Marquee Banner */}
      <div className="footer-marquee">
        <div className="marquee-track">
          <span>INDIA'S LARGEST GROWING QSR</span>
          <span>•</span>
          <span>100% REAL CHICKEN</span>
          <span>•</span>
          <span>BOLD FLAVOURS</span>
          <span>•</span>
          <span>13+ YEARS EXPERIENCE</span>
          <span>•</span>
          <span>INDIA'S LARGEST GROWING QSR</span>
          <span>•</span>
          <span>100% REAL CHICKEN</span>
          <span>•</span>
          <span>BOLD FLAVOURS</span>
          <span>•</span>
          <span>13+ YEARS EXPERIENCE</span>
          <span>•</span>
        </div>
      </div>

      <br />

      <div className="footer-content container">
        {/* Brand Section */}
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img 
              src="/logo.png" 
              alt="BIGGUYS Logo" 
              className="footer-logo-image" 
            />
          </Link>
          <p className="footer-tagline">
            Crafting the Future of QSR Fried Chicken
          </p>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/bigguysindia/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>{siInstagram.title}</title>
                <path fill="#FF0069" d={siInstagram.path} />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61556784862328"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Facebook"
            >
              <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>{siFacebook.title}</title>
                <path fill="#0866FF" d={siFacebook.path} />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@BigguysIndia"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="YouTube"
            >
              <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>{siYoutube.title}</title>
                <path fill="#FF0000" d={siYoutube.path} />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/bigguys/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="LinkedIn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                <path fill="#0a66c2" d="M196.3 512L103.4 512L103.4 212.9L196.3 212.9L196.3 512zM149.8 172.1C120.1 172.1 96 147.5 96 117.8C96 103.5 101.7 89.9 111.8 79.8C121.9 69.7 135.6 64 149.8 64C164 64 177.7 69.7 187.8 79.8C197.9 89.9 203.6 103.6 203.6 117.8C203.6 147.5 179.5 172.1 149.8 172.1zM543.9 512L451.2 512L451.2 366.4C451.2 331.7 450.5 287.2 402.9 287.2C354.6 287.2 347.2 324.9 347.2 363.9L347.2 512L254.4 512L254.4 212.9L343.5 212.9L343.5 253.7L344.8 253.7C357.2 230.2 387.5 205.4 432.7 205.4C526.7 205.4 544 267.3 544 347.7L544 512L543.9 512z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Links Container */}
        <div className="footer-links-container">
          {/* Company Links */}
          <div className="footer-links-section">
            <h4 className="footer-links-title">Company</h4>
            <ul className="footer-links">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Explore Links */}
          <div className="footer-links-section">
            <h4 className="footer-links-title">Explore</h4>
            <ul className="footer-links">
              {footerLinks.explore.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h4 className="footer-links-title">Get in Touch</h4>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-label">Email</span>
              <a href="mailto:franchise@bigguys.in">
                {/* <MdEmail size={20} color="#E4002B" className="contact-icon" /> */}
                franchise@bigguys.in
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-label">Phone</span>
              <a href="tel:+919986180513">
                {/* <MdPhone size={20} color="#E4002B" className="contact-icon" /> */}
                (+91) 9986180513
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-label">Address</span>
              <p>
                {/* <MdLocationOn size={20} color="#E4002B" className="contact-icon" /> */}
                Electronic City, Bengaluru, Karnataka, India
              </p>
            </div>
          </div>
        </div>
      </div>
<br />
      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2026 All Rights Reserved By Bigguy's Wings and more.
              <span className="parent-brand">From the house of Beamer Brands Pvt Ltd</span>
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
          <p className="concept-credit">
            Concept redesign created independently by Dhivijit as a design exploration
          </p>
        </div>
      </div>
    </footer>
  )
}
